export enum LanguageFlag {
  ZH = 0,
  EN = 1,
}
